import { NOTIFICATION_DEVICE_ID_KEY, NOTIFICATION_FCM_TOKEN_KEY } from '../constants/notifications';
import { getAccessToken } from '../utils/authToken';

/**
 * Unregisters the web push device while the user is still authenticated.
 * Clears local storage first so unmount/logout cleanups do not repeat the DELETE.
 */
export async function unregisterNotificationDevice(): Promise<void> {
  const raw = localStorage.getItem(NOTIFICATION_DEVICE_ID_KEY);
  localStorage.removeItem(NOTIFICATION_DEVICE_ID_KEY);
  localStorage.removeItem(NOTIFICATION_FCM_TOKEN_KEY);

  if (!raw) return;

  const id = Number(raw);
  if (!Number.isFinite(id)) return;

  const token = getAccessToken();
  if (!token) return;

  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) return;

  try {
    const response = await fetch(`${baseUrl}/notifications/devices/${id}/`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok && response.status !== 404) {
      console.warn('[FCM] DELETE /notifications/devices/ failed:', response.status);
    }
  } catch (error) {
    console.warn('[FCM] DELETE /notifications/devices/ failed:', error);
  }
}
